<template>
  <footer>
    <div class="container">
      <div class="foot-container">
        <div class="mr-auto">
          <div class="foot-copyright" v-html="settings.copyright">
          </div>
        </div>
        <div class="foot-qrcode">
          <div class="">
            <img :src="assetsPath +'static/images/qrcode.jpg'" style="width:140px;">
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
export default {
  name: 'AppFooter',
  mixins: [tools],
  computed: {
    ...mapGetters(['settings'])
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@media (min-width: 1200px) {
  .container{max-width:100%;}
}
.container {
  color:#8b939d;
  background-color:#2c2e2e;
}
.foot-container {
  .flex-center();
  margin:0 auto;
  padding:2rem;
  max-width:@appwidth;
  justify-content:space-between;
  .foot-qrcode {
    img {
      width:140px;
    }
  }
}
.foot-copyright {
  a {
    color:#8b939d;
  }
}
</style>